import React from 'react';
import RakeMovementReport from './RakeMovementReport';

const RakeMovementReportPage = () => {
  return (
    <div className="space-y-6">
      <RakeMovementReport />
    </div>
  );
};

export default RakeMovementReportPage;
